module.exports = __webpack_public_path__ + "static/img/mpu-1.3740327.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/mpu-1.svg
// module id = MgQ0
// module chunks = 0